
import { useEffect, useState } from 'react'

import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react'

import { initializeMsal, msalInstance } from '@/utils/auth'
import UnauthenticatedView from '@views/UnauthenticatedView'

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  const [msalReady, setMsalReady] = useState(false);

  useEffect(() => {
    (async () => {
      await initializeMsal();
      setMsalReady(true);
    })()
  }, []);

  if (!msalReady) return null

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnauthenticatedView />
      </UnauthenticatedTemplate>
    </MsalProvider>
  )
}
